module.exports = __webpack_public_path__ + "assets/images/users-plus-emerald.svg?4d39ebc93838048cc6640e741b65773e";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/users-plus-emerald.svg
// module id = 634
// module chunks = 0